export enum OrganisationStatus {
  LINKED = 'linked',
  BLOCKED = 'blocked'
}